import { toNumber } from 'lodash';

import { numberWithCurrency } from './numberWithCurrency';

export const numberWithTwoDecimals = (value) => toNumber(value).toFixed(2);

export const numberWithLessDecimals = (value) =>
  parseFloat(numberWithTwoDecimals(value)).toString();

export { numberWithCurrency };

export const numberWithCurrencyWithFallback = (
  value,
  locale = null,
  currency = null,
) => {
  if (!value || value === '0.0') {
    return '-';
  }

  return numberWithCurrency(value, currency, {
    locale: locale || I18n.locale,
    currencyDisplay: 'narrowSymbol',
  });
};
